import { hasAvailableAction } from '../../ui/gov-actions'
import { reportList } from './reports'
import { validateCCSStartDate, afterCCSStarted, validCCSClaimRange } from './reports/helpers'

export const currentReport = ({ report_id }) => reportList.filter(({ id }) => id === report_id)[0]

export const availableReports = payload =>
  reportList.filter(report => hasAvailableAction(payload, report.id))

export { validateCCSStartDate, afterCCSStarted, validCCSClaimRange }



// WEBPACK FOOTER //
// ./src/provider-level/reports/helpers.jsx